<div class="mb-6" *ngFor="let alert of alerts" (click)="removeAlert(alert)">
    <fuse-alert 
    [appearance]="alert.appearance" 
    [dismissible]="alert.dismissible" 
    [dismissed]="alert.dismissed"
    [type]="alert.type">
        <span *ngIf="alert.title" fuseAlertTitle>{{alert.title}}</span>
        <span style="white-space: pre-line;">{{alert.message}}</span>
    </fuse-alert>
</div>